import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65309321"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row g-0 d-none d-lg-flex" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  ref: "outer",
  class: "timeline-outer"
}
const _hoisted_4 = {
  ref: "timeline",
  class: "timeline"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline__delimiter" }, null, -1))
const _hoisted_6 = { class: "timeline__dates" }
const _hoisted_7 = { class: "m-0 p-0 d-flex justify-content-between" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "timeline__dot"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "timeline__tooltip futura fs-12",
              style: _normalizeStyle({left: `${_ctx.tooltipX}px`})
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.activeTooltip.tooltip), 1)
            ], 4),
            _createElementVNode("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tooltips, (panel, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  ref_for: true,
                  ref: `panel_${index + 1}`,
                  key: index,
                  class: _normalizeClass(['futura position-relative', `panel_${index + 1}`, {'active': panel.label === _ctx.activeTooltip.label}]),
                  onClick: ($event: any) => (_ctx.slideToPanel(index + 1))
                }, [
                  (panel.visible)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(panel.label), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10))
                ], 10, _hoisted_8))
              }), 128))
            ])
          ])
        ], 512)
      ], 512)
    ])
  ]))
}